import slider from "../components/slider";

slider("image-slider", {
    type: "carousel",
    startAt: 0,
    perView: 6,
    gap: 20,
    peek: {
        before: 0,
        after: 65
    },
    breakpoints: {
        1000: {
            perView: 5
        },
        800: {
            perView: 4
        },
        480: {
            perView: 3,
            gap: 10,
            peek: {
                before: 0,
                after: 25
            }
        }
    }
});

slider("image-slider-large", {
    type: "carousel",
    startAt: 0,
    perView: 5,
    breakpoints: {
        600: {
            perView: 2
        }
    }
});